
import React from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Mail, MessageCircle } from "lucide-react";

const ContactInfo = () => {
  return (
    <div className="space-y-6">
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <Mail className="w-5 h-5 text-primary" />
            Email Support
          </CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-muted-foreground mb-2">
            Send us an email and we'll respond as soon as possible.
          </p>
          <a 
            href="mailto:contact@snaprefund.com"
            className="text-primary hover:underline font-medium"
          >
            contact@snaprefund.com
          </a>
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <MessageCircle className="w-5 h-5 text-primary" />
            Quick Help
          </CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-muted-foreground mb-3">
            Check our FAQ for instant answers to common questions.
          </p>
          <Button variant="outline" size="sm" asChild>
            <Link to="/faq">Visit FAQ</Link>
          </Button>
        </CardContent>
      </Card>
    </div>
  );
};

export default ContactInfo;
